import React from 'react';
import {Edit} from 'react-admin';
import {BankForm} from './BankForm';

export const BankEdit = (props: unknown): React.ReactElement => <Edit {...props}>
    <BankForm {...props}/>
</Edit>;

